import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import {
  MotifFormField,
  MotifLabel,
  MotifSelect,
  MotifOption,
} from "@ey-xd/motif-react";

type ControlSelectBoxAttributeProps = {
  index: number;
  groupIndex?: number;
  disable?: boolean;
  control: any;
  attributes: {
    propertyName: string;
    displayName?: string;
    entityName: string;
  }[];
  handleAttributeChange: (
    index: number,
    attribute: string,
    groupIndex?: number
  ) => void;
};

const ControlSelectBoxAttribute = ({
  index,
  groupIndex,
  control,
  attributes,
  disable,
  handleAttributeChange,
}: ControlSelectBoxAttributeProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    const btn = document.querySelectorAll(
      ".motif-select-input"
    ) as NodeListOf<Element>;
    btn.forEach((element: Element) => {
      (element as HTMLElement).setAttribute("type", "button");
    });
  }, []);
  const path =
    groupIndex !== undefined
      ? `treeRows.${index}.treeRows.${groupIndex}`
      : `treeRows.${index}`;
  function getAttributeValue(filedValue: string) {
    let filteredValue: any = attributes.find((attr) => {
      if (`${attr.entityName}.${attr.propertyName}` === filedValue) {
        return true;
      }
      return false;
    });
    let value = "";
    if (filteredValue) {
      value = filteredValue.displayName;
    }
    return value;
  }
  return (
    <MotifFormField className="tree-Attribute-field">
      <MotifLabel id="select-label">
        {t("pages.configuration.scheme.rule.attributes")}
      </MotifLabel>
      <Controller
        name={`${path}.attribute`}
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState: { error } }) => {
          return (
            <div title={getAttributeValue(field.value)}>
              <MotifSelect
                className={`tree-attribute-select`}
                ariaLabelledBy="select-label"
                onChange={(value) => {
                  field.onChange(value);
                  handleAttributeChange(index, value, groupIndex);
                }}
                disabled={disable}
                placeholder="Select"
                value={field.value}
                filter={true}
                visibleOptions={5}
              >
                {attributes.map((attr) => (
                  <MotifOption
                    key={`${attr.propertyName}-${attr.entityName}`}
                    value={`${attr.entityName}.${attr.propertyName}`}
                    title={attr.displayName}
                    className="tree-attribute-option"
                  >
                    {attr.displayName}
                  </MotifOption>
                ))}
              </MotifSelect>
            </div>
          );
        }}
      />
    </MotifFormField>
  );
};

export default ControlSelectBoxAttribute;
